"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _OrderDetail = _interopRequireDefault(require("../components/OrderDetail.vue"));
var _permission = require("@/utils/permission");
var _filters = require("@/filters");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'paidMembersOrder',
  components: {
    OrderDetail: _OrderDetail.default
  },
  data: function data() {
    return {
      tableFrom: {
        cardName: '',
        dateLimit: '',
        page: 1,
        limit: 20,
        orderNo: '',
        payType: null,
        payStatus: null,
        userNickname: '',
        searchType: 'all',
        content: ''
      },
      cardName: '',
      userNickname: '',
      orderNoSeach: '',
      timeVal: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:paid:member:order:page:list'])) this.getList();
  },
  methods: {
    paidFilter: _filters.paidFilter,
    //详情
    handleInfo: function handleInfo(id) {
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    /**
     *  具体日期
     */
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = this.timeVal ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    /**
     *  列表
     */
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.cardName = encodeURIComponent(this.cardName);
      this.tableFrom.userNickname = encodeURIComponent(this.userNickname);
      this.tableFrom.orderNo = encodeURIComponent(this.orderNoSeach);
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _user.memberOrderListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
        _this.$message.error(res.message);
      });
    },
    reset: function reset() {
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.cardName = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.page = 1;
      this.tableFrom.limit = 20;
      this.tableFrom.orderNo = '';
      this.tableFrom.payType = null;
      this.tableFrom.payStatus = null;
      this.tableFrom.userNickname = '';
      this.timeVal = [];
      this.cardName = '';
      this.orderNoSeach = '';
      this.userNickname = '';
      this.getList(1);
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
    }
  }
};